export const saleRoutes = {
  complaint: {
    list: '/kinh-doanh/khieu-nai',
    goToDetail: (id: number | string) => `/kinh-doanh/khieu-nai/${id}`
  }
};
